export class ListCustomCursor {
	constructor() {
		this.container = document.querySelector('.listCustomCursor');

		this.allLink = this.container.querySelectorAll(
			'.listCustomCursor-listLink:not([aria-hidden="true"]) a, .listCustomCursor-listLink:not([aria-hidden="true"]) button'
		);
		this.allLinkMask = this.container.querySelectorAll(
			'.listCustomCursor-listLink[aria-hidden="true"] a, .listCustomCursor-listLink[aria-hidden="true"] button'
		);
		this.allImages = this.container.querySelectorAll(
			'.listCustomCursor-left li'
		);

		this.buttonPopup = this.container.querySelectorAll(
			'.listCustomCursor-listLink[aria-hidden="true"] button'
		);
	}

	init() {
		this.allLinkMask.forEach((linkMask, index) => {
			linkMask.addEventListener('mouseenter', () => {
				this.allImages.forEach((image) => {
					if (image.classList.contains('active')) {
						image.classList.remove('active');

						const timeout = setTimeout(() => {
							image.classList.remove('show');
							clearTimeout(timeout);
						}, 50);
					}
				});

				this.allImages[index].classList.add('active');
				const timeout = setTimeout(() => {
					this.allImages[index].classList.add('show');
					clearTimeout(timeout);
				}, 50);

				this.allImages[index].classList.add('active');
				this.allLink[index].classList.add('hover');
			});

			linkMask.addEventListener('mouseleave', () => {
				this.allLink.forEach((linkMask) => {
					if (linkMask.classList.contains('hover'))
						linkMask.classList.remove('hover');
				});
			});
		});

		if (this.buttonPopup) {
			this.buttonPopup.forEach((button) => {
				button.addEventListener('click', (event) => {
					this.autoAdvancePopup(event.target.textContent);
				});
			});
		}
	}

	autoAdvancePopup(text) {
		console.log(text);
		const containerPopulate = document.querySelector(
			'.module-popup-contact .redboxPopulateCptTitles'
		);

		const goodJob = containerPopulate.querySelector(
			`input[value="${text.trim()}"]`
		);
		goodJob.checked = true;

		goodJob
			.closest('.gform_page')
			.querySelector('.gform_next_button')
			.click();
	}
}
